// src/stores/notificationsStore.js
import { defineStore } from 'pinia';
import NotificationsService from '@/services/notificationsService';

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    notificationCount: 0,
    notifications: [],
    loading: false,
  }),

  getters: {
    hasUnreadNotifications: (state) => state.notificationCount > 0,
    recentNotifications: (state) => state.notifications.slice(0, 5)
  },

  actions: {
    async loadNotificationCount() {
      try {
        const response = await NotificationsService.getUnreadCount();
        this.notificationCount = response.data.count || 0;
      } catch (error) {
        console.error('Erreur lors du chargement du compteur de notifications:', error);
      }
    },

    async loadRecentNotifications(params = {}) {
      this.loading = true;
      try {
        const response = await NotificationsService.getUserNotifications(params);
        this.notifications = response.data.data;
        this.loading = false;
        return response.data;
      } catch (error) {
        console.error('Erreur lors du chargement des notifications récentes:', error);
        this.loading = false;
        // throw new Error("Erreur lors du chargement des notifications récentes", error);
      }
    },

    async updateNotificationCount(count = null) {
      if (count !== null) {
        this.notificationCount = count;
      } else {
        // Si aucun nombre n'est fourni, actualiser depuis l'API
        try {
          const response = await NotificationsService.getUnreadCount();
          this.notificationCount = response.data.count || 0;
        } catch (error) {
          console.error('Erreur lors de la mise à jour du compteur de notifications:', error);
        }
      }
    },

    addNotification(notification) {
      this.notifications.unshift(notification);
      if (this.notifications.length > 20) {
        this.notifications.pop(); // Limiter la taille du tableau
      }
      this.updateNotificationCount();
    }
  }
});